import { SimpleGrid } from "@chakra-ui/react";
import useDeviceSize from "hooks/useDeviceSize";
import { TeamCard } from "./TeamCard/TeamCard";
import type { TeamCardsProps } from "./TeamCards.d";
import { TeamCardsMobile } from "./TeamCardsMobile";

export const TeamCards = ({ cards }: TeamCardsProps) => {
  const { isMobile } = useDeviceSize();

  return isMobile ? (
    <TeamCardsMobile cards={cards} />
  ) : (
    <SimpleGrid columns={cards.length % 2 ? { base: 1, lg: 3 } : { base: 2, lg: 3 }} spacing={8} alignContent="center">
      {cards.map((card) => (
        <TeamCard key={card.name} {...card} />
      ))}
    </SimpleGrid>
  );
};
